<template lang="">
    <div>
        <!-- Inicio:: Dialog para seleccionar el valor de una respuesta para una validación-->
        <v-dialog
            v-model="dialog"
            maxWidth="900px" 
            persistent 
            transition="dialog-bottom-transition">

            <v-card>
                <v-card-title>
                    {{modalTitle}}
                    
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        :disabled="btnRegistroLoading"
                        @click="dialog = false; resetForm()"
                        class="float-right"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                
                 <v-form ref="myForm"
                        v-on:submit.prevent="seleccionarIdRespuesta"
                        v-model="validForm">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                                    <v-select
                                        v-model="indiceSeleccionadoId"
                                        :items="indices"
                                        :loading="ddIndicesLoading"
                                        dense
                                        outlined
                                        label="Seleccionar Índice"
                                        item-text="nombreIndice"
                                        item-value="id"
                                        :no-data-text="indices ? 'Selecciona un índice' : 'No se han registrado índices'"
                                        @change="obtenerPreguntasPorIndice(indiceSeleccionadoId)"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                                    <v-select
                                        v-model="preguntaSeleccionadaId"
                                        :items="preguntas"
                                        :loading="ddPreguntasLoading"
                                        dense
                                        outlined
                                        label="Seleccionar Pregunta"
                                        item-text="textoPregunta"
                                        item-value="id"
                                        :no-data-text="preguntas.length > 0 ? 'Selecciona una pregunta' : 'No se han encontrado preguntas para el índice seleccionado'"
                                        @change="obtenerRespuestasPorPregunta(preguntaSeleccionadaId)"
                                    ></v-select>
                                </v-col>


                                
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                                    <v-select
                                        v-model="respuestaSelecionadaId"
                                        :items="respuestas"
                                        :loading="ddRespuestasLoading"
                                        dense
                                        outlined
                                        label="Seleccionar Respuesta"
                                        item-text="textoRespuesta"
                                        item-value="id"
                                        :no-data-text="respuestas.length ? 'Selecciona una respuestas' : 'No se encontraron respuestas para la pregunta seleccionada.'"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                                <v-btn
                                    color="grey lighten-5"
                                    elevation="0"
                                    class="mb-2 float-right grey lighten-5"
                                    @click="dialog = false; resetForm()"
                                    :disabled="btnRegistroLoading"
                                >
                                    Cancelar
                                </v-btn>
                                <!--:disabled="!validDocForm" type="submit"-->
                                <v-btn
                                    color="primary"
                                    class="mb-2 float-right"
                                    type="submit"
                                    :elevation="0" 
                                    :disabled="!validForm" 
                                    :loading="btnRegistroLoading"                         
                                >
                                    Seleccionar
                                </v-btn>
                        </v-card-actions>
                    </v-form>

            </v-card>

        </v-dialog>        
        <!-- Fin:: Dialog para seleccionar el valor de una respuesta para una validación-->
    </div>
</template>
<script>
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_PREGUNTAS_POR_INDICE } from "@/core/services/store/pregunta.module";
import { OBTENER_RESPUESTAS } from "@/core/services/store/preguntas/respuestas/respuesta.module";
export default {

    data() {
        return {
            validForm:false,
            dialog:false,
            indices: [],
            indiceSeleccionadoId: 0,
            ddIndicesLoading:false,
            ddPreguntasLoading:false,
            ddRespuestasLoading:false,
            btnRegistroLoading:false,
            preguntas: [],
            preguntaSeleccionadaId: 0,
            respuestas: [],
            respuestaSelecionadaId:0,
            modalTitle: 'Seleccionar una respuesta',
            respuestaValidacionId: 0,
        }
    },

    methods: {

        resetForm(){
            this.respuestas=[];
            this.preguntas=[];
            this.respuestaSelecionadaId=0;
            this.preguntaSeleccionadaId=0;

        },

        //!Obtener Indices
        async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                    this.dialog=true;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });

        },

        //!Obtener todas las preguntas por indice
        async obtenerPreguntasPorIndice(indiceId){
            this.ddPreguntasLoading=true;
            this.preguntas=[];
            await this.$store
            .dispatch(OBTENER_PREGUNTAS_POR_INDICE, {indiceId:indiceId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.preguntas = res.data;
                } else {
                    //console.warn(res.message)
                    let message=`Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema`;
                    if(res.message){
                        message = res.message;
                    }
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', message);
                }
                this.ddPreguntasLoading=false;
            })
            .catch(() => {
                this.ddPreguntasLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });
        },


        //!Obtener las respuestas por pregunta seleccionada
        async obtenerRespuestasPorPregunta(preguntaId){
            this.respuestas=[];
            this.ddRespuestasLoading=true;
            await 
            this.$store.dispatch(OBTENER_RESPUESTAS,{preguntasId: preguntaId})
            .then(response => {
                //console.log(response)
                if(response.status==200){
                    this.respuestas=response.data;
                } else{
                    this.respuestas=[];
                }   
                this.ddRespuestasLoading=false;
            })
            .catch(err=>{
                console.log(err)
                this.ddRespuestasLoading=false;
            })
        },


        seleccionarIdRespuesta(){
            console.log(this.respuestaSelecionadaId)

            this.$emit('setValorPorRespuesta', this.respuestaSelecionadaId);
        }

    }
    
}
</script>
